import React from "react";
import PropTypes from "prop-types";
const SubMainContainer = (props) => {
  return (
    <div className={props.SubMainContainerCustomClass}>{props.children}</div>
  );
};
SubMainContainer.propTypes = {
  SubMainContainerCustomClass: PropTypes.string,
};

SubMainContainer.defaultProps = {
  SubMainContainerCustomClass: "layoutM",
};
export default SubMainContainer;
